import {fontSize, sizes} from "patient-ping-remedy/packages/theme";
import React from "react";
import styled from "@emotion/styled";
import TableAccordion from "patient-ping-remedy/packages/table-accordion";
import {DisplaySmallTypography} from "patient-ping-remedy/packages/typography";
import {CareJourneyDetailsResponse, AdditionalEvent} from "@/api/dto/care-journey";
import Helpers from "@/helpers/helpers";

type Props = {
  careJourneyDetails: CareJourneyDetailsResponse | undefined;
  additionalEvents?: AdditionalEvent[] | undefined;
}

const StyledTableAccordion = styled(TableAccordion)`
  background: transparent;
  padding: ${sizes.medium};
`;

const StyledPreBlock = styled.pre`
  font-size: ${fontSize.small};
  display: block;
  background-color: rgb(229 231 235);
  padding: 5px 10px;
`;

const RawTaskJson = (props: Props) => {
  const eventLogs = props.careJourneyDetails?.eventLogs;
  const rawOeResponse = props.careJourneyDetails?.orchestrationEngineDetails?.rawResponse;
  return (
    <>
      <StyledTableAccordion
        headerItems={[<DisplaySmallTypography>Original OE response</DisplaySmallTypography>]}
        isOpen={true}
      >
        <StyledPreBlock>
          {rawOeResponse
            ? JSON.stringify(rawOeResponse, null, 2)
            : 'No raw Orchestration Engine response available'}
        </StyledPreBlock>
      </StyledTableAccordion>
      <StyledTableAccordion headerItems={[<DisplaySmallTypography>Transformed response</DisplaySmallTypography>]}
        isOpen={true}>
        <StyledPreBlock>
          {JSON.stringify(props.careJourneyDetails, null, 2)}
        </StyledPreBlock>
      </StyledTableAccordion>
      <StyledTableAccordion
        headerItems={[
          <DisplaySmallTypography>Additional Events (Rejected Referrals)</DisplaySmallTypography>
        ]}
        isOpen={true}>
        <StyledPreBlock>
          {props.additionalEvents && props.additionalEvents.length > 0
            ? JSON.stringify(props.additionalEvents, null, 2)
            : 'No additional events available'}
        </StyledPreBlock>
      </StyledTableAccordion>
      <StyledTableAccordion
        headerItems={[<DisplaySmallTypography>Events</DisplaySmallTypography>]}
        isOpen={true}>
        {eventLogs?.map((log) => {
          const jsonBody = Helpers.safeJsonParse(log.messageBody);
          return <StyledTableAccordion
            key={log.messageId}
            headerItems={[log.stepName, log.eventType, log.eventDatetime, jsonBody.subject]}
            isOpen={true}>
            <StyledPreBlock>
              {JSON.stringify(jsonBody, null, 2)}
            </StyledPreBlock>
          </StyledTableAccordion>;
        })}
      </StyledTableAccordion>
    </>
  );
};

export default RawTaskJson;
